module.exports = __webpack_public_path__ + "img/1.cb569f41.jpg";